<template>
    <ul>
        <li v-for="item in items"
            :key="item.name"
            :class="{ active: nav.menuItemIsActive(item.name) }"
        >
            <router-link :to="item.name">{{ t(item.title) }}</router-link>
        </li>
    </ul>
</template>

<script setup>
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    // import stores from '@/stores';

    const nav = stores.nav();
    const user = stores.user();
    const { t } = useI18n();

    const items = computed(() => {
        const roles = user.profile?.roles?.map(item => item.roleId) || [];

        return nav.menu.filter(item => !item.permission?.length ||
            item.permission.some(role => roles.indexOf(role) !== -1 || (role === 'artist' && user.isArtist)))
    });
</script>

<style lang="scss" scoped>
ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0 0 auto;
    flex-shrink: 0;
    z-index: 1;
    width: 100%;

    li {
        display: flex;
        flex: 1 1 100%;
        width: 100%;

        a,
        button {
            flex: 1 1 100%;
            height: 42px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: start;
            font: var(--font-body-1);
            color: var(--white-80);
            padding: 0 24px;
            transition: all .4s;

            &:hover {
                color: var(--white-500);
            }
        }

        &.active {
            a, button {
                color: var(--white-500);
                font-weight: bold;
            }
        }
    }
}
</style>
